import { defineStore } from 'pinia'
import { loginUser, logoutUser } from '../services/api/auth'

const RICERCA_DEFAULT = {
  lang: null,
  latitudine: 41.89555493597798,
  longitudine: 12.482594400644304,
  quota: 0,
  distanza: 5,
  rugosita: null,
  vento: '110 Km/h',
  vento_v0: '25 m/s',
  bounds: null,
  indirizzo: '',
  in_italia: true,
  tipoPalo: null,
  configurazione: { codice: 'standard', descrizione_ita: 'standard', descrizione_eng: 'standard' },
  altezza: 0,
  sporgenza: 0,
  superficie: 0.1,
  tiro_max_progetto: 0,
  con_cappello: 'false',
  tipologia_proiettori: 'AS',
  potenza: 400,
  disposizione: '180',
  email: {},
  num_proiettori: 1,
  sup_proiettori: { label: '0.1 m²', value: 1 }
}

export const useMainStore = defineStore('main', {
  state: () => ({
    apiUrl: import.meta.env.VITE_API,
    user: null,
    isLoggedIn: false,
    ricerca: { ...RICERCA_DEFAULT }
  }),

  actions: {
    async login({ username, password }) {
      try {
        await loginUser(username, password)
        this.user = username
        this.isLoggedIn = true
      } catch (error) {
        this.logout()
        throw error
      }
    },

    logout() {
      logoutUser()
      this.user = null
      this.isLoggedIn = false
    },

    aggiornaRicerca(ricerca) {
      this.ricerca = ricerca
    },

    resetRicerca() {
      this.ricerca = { ...RICERCA_DEFAULT }
    }
  }
})
